import DashboardLayout from "../components/dashboard-layout";
import { useAuth } from "../App";
import { useNavigate } from "react-router-dom";

function getInitials(name) {
  if (!name) return "?";
  return name.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2);
}

export default function Profil() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    if (window.confirm("Apakah kamu yakin ingin keluar dari akun?")) {
      logout();
      navigate("/login");
    }
  };

  return (
    <DashboardLayout>
      <div className="profile-page">
        {/* Avatar Card */}
        <div className="profile-avatar-card">
          <div className="profile-avatar-circle">
            {getInitials(user?.name)}
          </div>
          <h2 className="profile-name">{user?.name || "User"}</h2>
          <p className="profile-email">{user?.email || "-"}</p>
          <div className="profile-role-badge">
            <span>🛡️</span> Anggota Aktif
          </div>
        </div>

        {/* Info Akun */}
        <div className="profile-section">
          <p className="profile-section-title">INFORMASI AKUN</p>
          <div className="profile-info-card">
            <div className="profile-info-row">
              <div className="profile-info-icon" style={{ background: "#EEF9FF" }}>👤</div>
              <div>
                <p className="profile-info-label">Nama Lengkap</p>
                <p className="profile-info-value">{user?.name || "-"}</p>
              </div>
            </div>
            <div className="profile-divider" />
            <div className="profile-info-row">
              <div className="profile-info-icon" style={{ background: "#F0FDF4" }}>📧</div>
              <div>
                <p className="profile-info-label">Email</p>
                <p className="profile-info-value">{user?.email || "-"}</p>
              </div>
            </div>
            <div className="profile-divider" />
            <div className="profile-info-row">
              <div className="profile-info-icon" style={{ background: "#FFF7ED" }}>🆔</div>
              <div>
                <p className="profile-info-label">ID Pengguna</p>
                <p className="profile-info-value">#{user?.id || "-"}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Menu */}
        <div className="profile-section">
          <p className="profile-section-title">PENGATURAN</p>
          <div className="profile-info-card">
            <button className="profile-menu-item" onClick={() => navigate("/tentang")}>
              <div className="profile-info-icon" style={{ background: "#EEF2FF" }}>ℹ️</div>
              <span className="profile-menu-label">Tentang Aplikasi</span>
              <span className="profile-menu-arrow">›</span>
            </button>
            <div className="profile-divider" />
            <button className="profile-menu-item" onClick={() => navigate("/bantuan")}>
              <div className="profile-info-icon" style={{ background: "#FEF3C7" }}>❓</div>
              <span className="profile-menu-label">Bantuan / FAQ</span>
              <span className="profile-menu-arrow">›</span>
            </button>
          </div>
        </div>

        {/* Logout */}
        <button className="profile-logout-btn" onClick={handleLogout}>
          🚪 Keluar dari Akun
        </button>

        <p className="profile-version">AiDuNode v1.0.0 · Universitas Negeri Malang</p>
      </div>
    </DashboardLayout>
  );
}
